import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async"; // React Helmet Async import edildi
import { useEffect } from "react";

export default function Bulunamadi() {
  // Sayfa yüklendiğinde cache kontrolü yapıyoruz (Prerender.io için)
  useEffect(() => {
    // Cache-Control başlıklarıyla sayfa cache'lenmesin
    if (window.location.pathname === '/404') {
      document.querySelector("meta[name='robots']").setAttribute("content", "noindex, nofollow");
      document.head.querySelector('meta[name="robots"]').setAttribute('content', 'noindex, nofollow');
    }
  }, []);

  return (
    <div className="container d-flex flex-column align-items-center text-center" style={{ minHeight: "calc(100vh - 56px)", marginTop: "56px" }}>
      {/* SEO Başlık ve Meta Tagları */}
      <Helmet>
        <title>404 - Sayfa Bulunamadı | Hacı Ali Kara</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="Üzgünüz, aradığınız sayfa bulunamadı. Ana sayfaya dönmek için buraya tıklayın." />
        <meta name="keywords" content="404, sayfa bulunamadı, Hacı Ali Kara" />
        <meta property="og:title" content="404 - Sayfa Bulunamadı" />
        <meta property="og:description" content="Üzgünüz, aradığınız sayfa bulunamadı. Ana sayfaya dönmek için buraya tıklayın." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.hacialikara.com/404" />
      </Helmet>

      <h1 className="display-1 fw-bold text-danger">404</h1>
      <p className="lead text-muted">Üzgünüz, aradığınız sayfa bulunamadı.</p>
      <Link to="/" className="btn btn-primary mt-3">Ana Sayfaya Dön</Link>
    </div>
  );
}
